"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCatalystCreateCase = void 0;
const fetchClient_1 = require("../../client/fetchClient");
const react_query_1 = require("react-query");
const paths_1 = require("../../paths");
const contexts_1 = require("../../contexts");
const utils_1 = require("../../utils");
const react_1 = require("react");
const logger_1 = require("../../logger");
function useCatalystCreateCase({ employeeId }) {
    const { clientName, currentStage } = (0, contexts_1.useTaaConfigsContext)();
    const dimensions = {
        ClientName: clientName,
        ClientType: logger_1.ClientType.WEB,
        EmployeeId: employeeId,
        DurationType: logger_1.DurationCategory.REPORT_TRAVEL_TIME,
        Duration: null
    };
    const { data, isLoading: loading, error, mutate } = (0, react_query_1.useMutation)((0, fetchClient_1.submitData)(currentStage));
    const [catalystCreateCaseData, setCatalystCreateCaseData] = (0, react_1.useState)(undefined);
    const [retryParams, setRetryParams] = (0, react_1.useState)();
    const path = (0, paths_1.SUBMIT_TRAVEL_TIME_API)({
        'x-myhr-client-id': 'MyHR_Catalyst',
        operation: '/create-case',
        employeeId: employeeId
    });
    const method = 'POST';
    const apiName = 'createCase';
    const catalystCreateCase = (payload, attachmentPayload, duration) => {
        setRetryParams(undefined);
        setCatalystCreateCaseData(undefined);
        mutate({
            path,
            method,
            eventName: utils_1.taaEvents.CREATE_CTK_CASE,
            body: {
                payload: JSON.stringify(payload),
                messageMetadata: {
                    employeeAlias: null,
                    employeeId: employeeId,
                    requesterLogin: null,
                    eventTimestamp: null,
                    language: null,
                    origin: 'ATOZTimeCard',
                    requesterType: 'EMPLOYEE',
                    requesterProfileType: null,
                    locale: null,
                    businessInput: null,
                    targetUseCase: null,
                    agentUseCase: null
                },
                attachments: attachmentPayload,
                employeeId,
                businessOwner: 'ATOZ-TimeCard-CentralizedTimeKeeping',
                useCase: 'ATOZ-TimeCard-CentralizedTimeKeeping'
            },
            metaData: {
                apiName,
                clientName,
                isLogResponse: true
            }
        }, {
            onSuccess: (data, variables, context) => {
                dimensions.Duration = duration;
                logger_1.logger.emitCountMetric({
                    metricName: logger_1.METRICS.CATALYST_CREATE_CASE_SUCCESS.COUNT,
                    dimensions
                });
                logger_1.logger.emitLatencyMetric({
                    metricName: 'travelTimeReportedDuration',
                    metricValue: duration,
                    metricUnit: logger_1.MetricUnit.HOURS,
                    dimensions
                });
                setCatalystCreateCaseData(JSON.parse(data === null || data === void 0 ? void 0 : data.response));
            },
            onError: (err) => {
                logger_1.logger.emitCountMetric({
                    metricName: logger_1.METRICS.CATALYST_CREATE_CASE_ERROR.COUNT,
                    dimensions
                });
                setRetryParams({ payload, attachmentPayload, duration });
            }
        });
    };
    const retry = () => {
        if (!retryParams || loading)
            return;
        const { payload, attachmentPayload, duration } = retryParams;
        catalystCreateCase(payload, attachmentPayload, duration);
    };
    return {
        catalystCreateCaseState: {
            data: catalystCreateCaseData,
            loading,
            error: retryParams ? error : null,
            retry
        },
        catalystCreateCase
    };
}
exports.useCatalystCreateCase = useCatalystCreateCase;
